import { render } from "./QualityComposition.vue?vue&type=template&id=4e4a4dbc"
import script from "./QualityComposition.vue?vue&type=script&lang=js"
export * from "./QualityComposition.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__